<template>
  <div>
    <el-select @focus="focus"
               filterable v-model="selectvalue" :placeholder="pleasett" value-key="_id" clearable
               remote
               :remote-method="remoteMethod"
               @change="selectdata">
      <el-option v-for="(item,index) in selectlist_datas" :value="{_id:item._id,name:item[temp.field.key]}" :label="item[temp.field.key]" :key="index">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import util from "../../../assets/js/util";

export default {
  props: ["temp", "field", "oem"],
  name: "dataselect",
  data() {
    return {
      pleasett: '请选择' + this.temp.field.name || '请选择',
      selectvalue: {},
      selectlist_datas: [],
      selectlaststatus: false
    }
  },
  async mounted() {
    this.selectvalue = this.temp.value
    setTimeout(() => {
      if (this.temp.value && this.temp.value._id) {
        this.pleasett = this.temp.value.name
      }
      this.$forceUpdate()
    }, 100)
    // this.focus()

  },
  methods: {
    updateinof() {

      this.selectlist_datas = [{_id: field.value._id, name: field.value.name}]
    },
    async remoteMethod(e) {
      if (!e) {
        this.selectlist_datas = []
        return
      }
      var key = [this.temp.field.key]

      this.selectlist_datas = await util.get_no("comprehensive", "server/getdata", {
        server: this.temp.server.server,
        key: key,
        value: e,
        oem: this.oem,
        uid: userinfo._id,
        menu_id: this.temp.menu_id
      })
      this.$forceUpdate()
    },
    async focus(key, value) {

      var select = []

      //条件
      if (this.temp.condition_me && JSON.stringify(this.temp.condition_me) != "{}") { //条件查询
        var value = {}
        for (var i = 0; i < this.field.length; i ++) {
          if (this.field[i].key == this.temp.condition_me.key) {

            if (!this.field[i].value && !this.field[i].value._id && this.selectlist_datas.length > 0) {
              util.error("请先选择" + this.field[i].name)
              return
            } else {
              value = this.field[i].value
            }
          }
        }


        // select = await util.post("comprehensive", "server/getdata", {
        //   server: this.temp.server.server,
        //   key: [this.temp.field.key],
        //   lasetkey: this.temp.condition.key,
        //   lasetvalue: value._id
        // })


      } else {
        var key = [this.temp.field.key]

        for (var eventfiedKey in this.temp.eventfied) {
          key.push(this.temp.eventfied[eventfiedKey])
        }

        select = await util.get_no("comprehensive", "server/getdata", {
          server: this.temp.server.server,
          uid: userinfo._id,
          oem: this.oem,
          key: key, menu_id: this.temp.menu_id
        })
      }
      if (select !== false) {
        this.selectlist_datas = select
      }
      this.selectvalue = this.temp.value

      this.$forceUpdate()
    },
    selectdata(e) {
      if (e) {
        e[this.temp.field.key] = e.name
      }

      //关联显示需要把另外一个字段赋值
      if (JSON.stringify(this.temp.eventfied) != "{}" && e) {
        this.selectlist_datas.forEach((item) => {
          if (item._id == e._id) {


            for (var objKey in this.temp.eventfied) {


              for (var i = 0; i < this.field.length; i ++) {
                var obj = this.field[i];

                if (obj.key == objKey) {
                  obj.value = item[this.temp.eventfied[objKey]]
                }


              }


            }
          }
        })
      }

      this.$emit("selectchange", e)

    }
  }
}
</script>

<style scoped>

/deep/ .el-input__inner::placeholder {
  color: rgba(0, 0, 0, 0.685) !important;
}
</style>



// WEBPACK FOOTER //
// src/page/module/util/dataselect.vue